"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmationSmsCodeFormController = ConfirmationSmsCodeFormController;
var React = _interopRequireWildcard(require("react"));
var _ContentLayout = require("../ContentLayout");
var _ConfirmationSmsCodeForm = require("../ConfirmationSmsCodeForm");
var _validation = require("../../utils/validation");
var _requestStatus = require("../../types/requestStatus");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ConfirmationSmsCodeFormController(_ref) {
  let {
    sendValidationCodeStatus,
    isSubmitting,
    hasCodeError,
    codeError,
    resendTimeout,
    source,
    verifyValidationCode,
    sendValidationCode,
    onResendClick
  } = _ref;
  const prevSendValidationCodeStatus = React.useRef(sendValidationCodeStatus);
  // FORM
  const [touched, setTouched] = React.useState(false);
  const [changed, setChanged] = React.useState(false);
  const [isTemporarilyBlocked, setTemporarilyBlocked] = React.useState(false);

  // CODE
  const codeRef = React.useRef(null);
  const [code, setCode] = React.useState('');
  const isCodeInvalid = React.useMemo(() => code === '' || code !== '' && !(0, _validation.isValidCode)(code), [code]);
  const [lastAttemptTimestamp, setLastAttemptTimestamp] = React.useState(new Date().getTime());
  const [resendAvailable, setResendAvailable] = React.useState(false);
  const validateCode = React.useCallback(code => {
    if (!(0, _validation.isValidCode)(code)) {
      if (codeRef.current) {
        codeRef.current.focus();
      }
      return;
    }
    verifyValidationCode(code);
    setChanged(false);
  }, [verifyValidationCode]);
  const handleChangeCode = React.useCallback(e => {
    const {
      value
    } = e.currentTarget;
    const newValue = value.replace(/\D/gi, '');
    if (newValue.length > 4) {
      return;
    }
    setChanged(true);
    setCode(newValue);
    validateCode(newValue);
  }, [validateCode]);
  const handleTimeoutExpired = React.useCallback(() => {
    setResendAvailable(true);
  }, []);
  const handleResendClick = React.useCallback(e => {
    e.preventDefault();
    if (onResendClick) {
      onResendClick(source);
    }
    if (sendValidationCodeStatus !== _requestStatus.ERequestStatus.Succeed) {
      return;
    }
    sendValidationCode();
    setCode('');
    if (codeRef.current) {
      codeRef.current.focus();
    }
  }, [sendValidationCodeStatus, source, sendValidationCode, onResendClick]);

  // FORM
  const handleSubmit = React.useCallback(() => {
    setTouched(true);
    validateCode(code);
  }, [code, validateCode]);
  React.useEffect(() => {
    if (prevSendValidationCodeStatus.current !== sendValidationCodeStatus) {
      if (sendValidationCodeStatus === _requestStatus.ERequestStatus.Failed) {
        setLastAttemptTimestamp(null);
      } else if (sendValidationCodeStatus === _requestStatus.ERequestStatus.Succeed) {
        setLastAttemptTimestamp(new Date().getTime());
      }
      setResendAvailable(false);
    }
    prevSendValidationCodeStatus.current = sendValidationCodeStatus;
  }, [sendValidationCodeStatus]);
  React.useEffect(() => {
    if (codeError === 'codeInputLimitReached') {
      setCode('');
      setTemporarilyBlocked(true);
    }
  }, [codeError]);
  React.useEffect(() => {
    if (codeRef.current) {
      codeRef.current.focus();
    }
  }, []);
  return /*#__PURE__*/React.createElement(_ContentLayout.ContentLayout, null, /*#__PURE__*/React.createElement(_ConfirmationSmsCodeForm.ConfirmationSmsCodeForm
  //FORM
  , {
    isSubmitting: isSubmitting,
    handleSubmit: handleSubmit,
    submitButtonText: "\u0412\u043E\u0439\u0442\u0438"
    //CODE
    ,
    codeRef: codeRef,
    code: code,
    onCodeChange: handleChangeCode,
    codeError: !changed && !isTemporarilyBlocked && codeError || undefined,
    isCodeInvalid: touched && (isCodeInvalid || !changed && hasCodeError),
    resendAvailable: resendAvailable,
    resendTimeout: resendTimeout,
    lastResendTime: lastAttemptTimestamp,
    onResendTimeoutExpired: handleTimeoutExpired,
    onResend: handleResendClick,
    isTemporarilyBlocked: isTemporarilyBlocked
  }));
}